import React from "react";
import MvModal from './MvModal'
// @ts-ignore
import { LocalizationContext } from 'react-localize';
// Styles
import "./InEligibleModal";
import "./modal.css";
import { logLinkInfoAnalyticData } from "Utils/analytics";

interface Props {
    ineligibleheader?: string;
    ineligibledescription: string;
    ineligiblebtn: string;
    abortLabel?: string;
    openModal: boolean;
    closeiconnato: boolean;
    toggleModal: () => void;
    abort: () => void;
    confirm: () => void;
};

class InEligibleModal extends React.Component<Props, {}> {

    render() {
        const { localize } = this.context;
        let modalBody;
        
            modalBody = (
                <div className='modal-body hopper-modal-body ineligible-modal-body'>
                    <p className="ineligible-text-h">{localize(this.props.ineligibleheader)}</p>
                    <p className="ineligible-text-p">{localize(this.props.ineligibledescription)}</p>
                    <button
                                type='button'
                                id='ineligible-previous-btn'
                                className='mv-button primary underline ineligible-return-btn'
                                ref='confirm'
                                onClick={()=> window.close()}
                            >
                                {localize(this.props.ineligiblebtn)}
                    </button>
                </div>
            );
        
        return (
            <MvModal
                id="hopper-modal"
                openModal={this.props.openModal}
                closeiconnato={this.props.closeiconnato}
                toggleModal={this.props.toggleModal}>
                <div className="hopper-confirmation-modal">
                    {modalBody}
                </div>
            </MvModal>
        );
    }
};

InEligibleModal.contextType = LocalizationContext;
export {
    InEligibleModal,
};
